// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__4Gp3E","buttons":"styles_buttons__yn5jX","message":"styles_message__HZ1t1","pushRight":"styles_pushRight__mXe3d","activateModal":"styles_activateModal__66LbW"};